module.exports = __webpack_public_path__ + "img/findmyweatherlogotransparant.c69da43f.png";